import {
  FETCH_CAMPAIGNS,
  FETCH_CAMPAIGNS_SUCCESS,
  DELETE_CAMPAIGN,
  DELETE_CAMPAIGN_SUCCESS,
  VALIDATE_AUDIENCE_CSV_FILE_SUCCESS,
  FETCH_SHARE_LIST,
  FETCH_SHARE_LIST_SUCCESS,
  CREATE_CAMPAIGN,
  CREATE_CAMPAIGN_SUCCESS,
  SET_CURRENT_SHARING_CAMPAIGN_ID
} from '../constants';



const initialState = {
  campaigns:[],
  campaignsLoading: false,
  validateResponse: null,
  shareList: [],
  shareListLoading: false,
  createCampaignLoading: false,
  currentSharingCampaignId: '',
};

const campaign = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CAMPAIGNS:
      return {
        ...state,
        campaignsLoading: true,
      };
    case FETCH_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        campaignsLoading: false,
        campaigns: action.data,
      };
    case DELETE_CAMPAIGN:
      return {
        ...state,
        campaignsLoading: true,
      };
    case DELETE_CAMPAIGN_SUCCESS:
      return {
        ...state,
        campaignsLoading: false,
      };
    case VALIDATE_AUDIENCE_CSV_FILE_SUCCESS:
      return {
        ...state,
        validateResponse: action.data
      };
    case FETCH_SHARE_LIST:
      return {
        ...state,
        shareListLoading: true,
      };
    case FETCH_SHARE_LIST_SUCCESS:
      return {
        ...state,
        shareList: action.data,
        shareListLoading: false,
      };
    case CREATE_CAMPAIGN:
      return{
        ...state,
        createCampaignLoading: true
      }
    case CREATE_CAMPAIGN_SUCCESS:
      return{
        ...state,
        createCampaignLoading: false
      }
    case SET_CURRENT_SHARING_CAMPAIGN_ID:
      return{
        ...state,
        currentSharingCampaignId: action.campaignId
      }
    default:
      return state;
  }
};

export default campaign;
